export default __webpack_public_path__ + "images/955528f6d09d298d6eb3844b051d5b22-appleStore.png";